/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'B'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAPB000001',
    EAPZ000003: 'EAPB000003',
    EAPZ000004: 'EAPB000004',
    EAPZ000018: 'EAPB000018',
    EAPZ000019: 'EAPB000019',
    EAPZ000020: 'EAPB000020',
    EAPZ000050: 'EAPB000050',
    EAPZ000051: 'EAPB000051',
    EBAZ000004: 'EBAB000004',
    EBAZ000005: 'EBAB000005',
    EBAZ000006: 'EBAB000006',
    EBAZ000007: 'EBAB000007',
    EBAZ000008: 'EBAB000008',
    EBAZ000009: 'EBAB000009',
    EBAZ000010: 'EBAB000010',
    EBAZ000011: 'EBAB000011',
    EBAZ000012: 'EBAB000012',
    EBAZ000013: 'EBAB000013',
    EBAZ000015: 'EBAB000015',
    EBAZ000104: 'EBAB000104',
    EBAZ000109: 'EBAB000109',
    EBAZ000111: 'EBAB000111',
    EBAZ000112: 'EBAB000112',
    EBAZ000113: 'EBAB000113',
    EBAZ000114: 'EBAB000114',
    EBAZ000115: 'EBAB000115',
    EBAZ000116: 'EBAB000116',
    EBAZ000117: 'EBAB000117',
    EBAZ000119: 'EBAB000119',
    EBAZ000120: 'EBAB000120',
    EBAZ000121: 'EBAB000121',
    EBAZ000122: 'EBAB000122',
    EBAZ000123: 'EBAB000123',
    EBAZ000124: 'EBAB000124',
    EBAZ000126: 'EBAB000126',
    EBAZ000127: 'EBAB000127',
    EBAZ000128: 'EBAB000128',
    EBAZ000293: 'EBAB000293',
    EBAZ000294: 'EBAB000294',
    EBAZ000319: 'EBAB000319',
    EBAZ000322: 'EBAB000322',
    EBAZ000349: 'EBAB000349',
    EBAZ000350: 'EBAB000350',
    EBAZ000351: 'EBAB000351',
    EBAZ000353: 'EBAB000353',
    EBAZ000355: 'EBAB000355',
    EBAZ000357: 'EBAB000357',
    EBAZ000358: 'EBAB000358',
    EBAZ000359: 'EBAB000359',
    EBAZ000363: 'EBAB000363',
    EBAZ000364: 'EBAB000364',
    EBAZ000379: 'EBAB000379',
    EBAZ000397: 'EBAB000397',
    EBAZ000398: 'EBAB000398',
    EBAZ000399: 'EBAB000399',
    EBAZ000496: 'EBAB000496',
    EBAZ000619: 'EBAB000619',
    EBAZ000644: 'EBAB000644',
    EBAZ000645: 'EBAB000645',
    EBAZ000647: 'EBAB000647',
    EBAZ000656: 'EBAB000656',
    EBAZ000721: 'EBAB000721',
    EBAZ000723: 'EBAB000723',
    EBAZ000731: 'EBAB000731',
    EBAZ000732: 'EBAB000732',
    EBAZ000733: 'EBAB000733',
    EBAZ000734: 'EBAB000734',
    EBAZ000774: 'EBAB000774',
    EBAZ000776: 'EBAB000776',
    EBAZ000781: 'EBAB000781',
    EBAZ000811: 'EBAB000811',
    EBAZ000812: 'EBAB000812',
    EBAZ000814: 'EBAB000814',
    EBAZ000816: 'EBAB000816',
    EBAZ000818: 'EBAB000818',
    EBAZ000819: 'EBAB000819',
    EBAZ000823: 'EBAB000823',
    EBAZ000892: 'EBAB000892',
    EBAZ000909: 'EBAB000909',
    EBAZ000999: 'EBAB000999',
    FDXZ000005: 'FDXB000005',
    FIFA000001: '',
  },
};

/**
 * ワーニングコードの定数定義
 */
export const WarningCodeConstants = {
  // ワーニングコード一覧(4桁目'B'とする)
  WARNING_CODES: {
    WBAZ000046: 'WBAB000046',
    WBAZ000047: 'WBAB000047',
    WBAZ000247: 'WBAB000247',
    WBAZ000252: 'WBAB000252',
    WBAZ000255: 'WBAB000255',
    WBAZ000570: 'WBAB000570',
    WBAZ000578: 'WBAB000578',
    WBAZ000579: 'WBAB000579',
    WBAZ000580: 'WBAB000580',
    WBAZ000581: 'WBAB000581',
    WBAZ000582: 'WBAB000582',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'ORC',
  TWO_LETTER: 'OC',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'NGSOC08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'NGSOC08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'NGSOC08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: '' as '' | 'alphaNumberic' | 'numberic',
    length: 0,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 0,
    maxPwLength: 0,
    pwRegex: '.*',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: false,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: false,
  LOGO_FILE_PATH: 'assets/images/logo_orc.svg',
  LOGO_S_FILE_PATH: 'assets/images/logo_orc_s.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: '',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {} as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  IMG: {
    // 全体
    ALL_EXTERNAL_PRIMARY: 'assets/images/icon_external_orc_navy_16.svg',
    ALL_EXTERNAL_RED: 'assets/images/icon_external_orc_red_16.svg',
    ALL_HELP_PRIMARY: 'assets/images/icon_help_orc_navy_24.svg',
    SUB_HEADER_HELP_WHITE: 'assets/images/icon_help_orc_white_navy_24.svg',
    ALL_CHECKINSTATUS_NOTACCEPTED: 'assets/images/icon_remove_orc_navy_20.svg',
    ALL_CHECKINSTATUS_ACCEPTED: 'assets/images/icon_feature_available_orc_cyan_24.svg',
    // C01-P040-S01-U チェックインシートマップ
    C01_P040_S01_U_SEATMAP_FLOAT_LEGEND: 'assets/images/seatmap_float_legend_orc.svg',
    C01_P040_S01_U_SEATMAP_FLOAT_SEATTYPE: 'assets/images/seatmap_float_seattype_orc.svg',
    C01_P040_S01_U_LEGENDS_SEAT_SELECTED: 'assets/images/seat_selected_orc_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_BEFORE_CHANGE_FREE_SEAT: 'assets/images/seat_before_change_free_seat_orc_24.svg',
    C01_P040_S01_U_LEGENDS_EMERGENCY_EXIT_SEAT: 'assets/images/seat_emergency_exit_seat_orc_24.svg',
    C01_P040_S01_U_LEGENDS_SEAT_LAVATORY: 'assets/images/seat_lavatory_orc_24.svg',
    C01_P040_S01_U_LEGENDS_GALLEY: 'assets/images/seat_galley_orc_24.svg',
    C01_P040_S01_U_LEGENDS_WING: 'assets/images/seat_wing_orc_24.svg',
  },
  ABLE_D_TRANSITION_PARAMETER: {
    EXTERNAL_FLG: 'NEWORC',
    ALLIANCE_FLG: 'ORC',
  },
} as const;
